












































import {Component, Vue} from 'vue-property-decorator';
import {Inject} from 'vue-typedi';
import {StoreService} from '@/services/StoreService';
import {SelectableStore} from '@/components/mass-import/SelectableStore';
import {GetStoresResponse} from '@/model/GetStoresResponse';
import SelectSitesStep from '@/components/mass-import/steps/SelectSitesStep.vue';
import BackupProductsStep from '@/components/mass-import/steps/BackupProductsStep.vue';
import UploadProductsStep from '@/components/mass-import/steps/UploadProductsStep.vue';
import CompletedStep from '@/components/mass-import/steps/CompletedStep.vue';
import Stepper from '@/components/mass-import/steps/Stepper.vue';
import {CsvValidation} from '@/helpers/csv/CsvValidation';

@Component({
  components: {Stepper, CompletedStep, UploadProductsStep, BackupProductsStep, SelectSitesStep}
})
export default class MassImportBody extends Vue {

  @Inject()
  storeService!: StoreService

  public currentStep: number = 1;
  public readonly selectableStores: SelectableStore[] = [];
  public readonly allStoresSelected: {value: boolean} = {value: false}; // immutable to update or keep alive all stores selection value while changing steps
  public readonly downloadedBackupBlobHrefContainer: {value?: string} = {value: null}; // immutable to update or keep alive backup value while changing steps
  public readonly uploadedFileContainer: {value?: File} = {value: null}; // immutable to update or keep alive import file value while changing steps
  public readonly uploadedFileCsvValidationContainer: {value: CsvValidation} = {value: new CsvValidation()}; // immutable to update or keep alive import file validation while changing steps

  mounted() {
    this.initStores();
    this.initSteps();
  }

  private initStores() {
    this.storeService.getStores()
        .then((response: GetStoresResponse) => {
          this.selectableStores.push(...response.stores
              .sort((a, b) => a.storeId.localeCompare(b.storeId))
              .map(store => new SelectableStore(store)));
        });
  }

  public initSteps() {
    this.currentStep = 1;
    this.selectableStores.forEach(selectableStore => {
      selectableStore.displayed = true;
      selectableStore.checked = false;
    });
    if (this.downloadedBackupBlobHrefContainer.value != null) {
      window.URL.revokeObjectURL(this.downloadedBackupBlobHrefContainer.value);
    }
    this.downloadedBackupBlobHrefContainer.value = null;
    this.uploadedFileContainer.value = null;
  }

  public nextStep() {
    this.currentStep++;
  }

  public previousStep() {
    if (this.currentStep == 2) {
      if (this.downloadedBackupBlobHrefContainer.value) {
        window.URL.revokeObjectURL(this.downloadedBackupBlobHrefContainer.value);
      }
      this.downloadedBackupBlobHrefContainer.value = null;
      this.uploadedFileContainer.value = null;
    }
    this.currentStep--;
  }
}

